import React,{ Fragment } from 'react'
import styled from 'styled-components'
import Ptag from './ptag'
import popupcrossbutton from '../../assets/images/popupcrossbutton.png'
import { formatAmount } from '../../utlis/utils'
const PaymentPopup = (props) => {


   const closePaymentPopup = (e) =>{
    e.stopPropagation();
    props.parentCallback(false);
   }


   const renderSummaryRow = (label, amt, color = null, margin = '12px 0 24px 0', fontSize,fontWeight) => {
    let rupee = color === "#f27576" ? "-₹" : "₹";
    return (
      <FlexRow margin={margin}>
        <Ptag fontSize={fontSize ? `${fontSize}px` : '14px'} letterSpacing='1px' fontWeight={fontWeight} color={color} >{label}</Ptag>
        <Ptag fontSize={fontSize ? `${fontSize}px` : '14px'} letterSpacing='0.5px' fontWeight={fontWeight} color={color}>
          {rupee + formatAmount(amt || 0)}
        </Ptag>
      </FlexRow>
    );
  };


  const renderAnnualDiscountRow = (label, amt, color , margin = '24px 0 8px 0') => {
    let rupee = color === "#f27576" ? "-₹" : "-₹";
    return (
      <FlexRow margin={margin}>
        <Ptag fontSize='20px' letterSpacing='0.2px' fontWeight="400" color={color}>{label}</Ptag>
        <Ptag fontSize='20px' letterSpacing='0.4px' fontWeight="400" color={"#f27576"}>
          {rupee + formatAmount(amt || 0)}
        </Ptag>
      </FlexRow>
    );
  };


  const getTotal = () =>{
    var subscription_amount = (props.paymentValues['premium'] || 0)+(props.paymentValues['platform_fee'] || 0)-(props.paymentValues['discount'] || 0)+(props.paymentValues['discounted_tax'] || 0) + (props.paymentValues['gpa_cost'] || 0)
    return subscription_amount
  }


  const paymentSummary = () => {
  
    return (
      <Fragment>
        <Card>
 
          <InnerWrapper>
            {renderSummaryRow("Total Subscription", ((props.paymentValues['premium'] || 0) + (props.paymentValues['platform_fee'] || 0) + (props.paymentValues['gpa_cost'] || 0)) , null, '0 0 2px 0', 20,400)}
            <SubComponentRow margin='0 0 3px 0px'>
              <Ptag fontSize='16px' letterSpacing='0.5px' fontWeight='300'>
                {'Insurance Premium'}
              </Ptag>
              <Ptag fontSize='16px' fontWeight='300' letterSpacing='0.3px'>
                {"₹" + formatAmount(props.paymentValues['premium'] || 0)}
              </Ptag>
            </SubComponentRow>
            {
              !!props.paymentValues['platform_fee'] &&
              <SubComponentRow margin='0 0 3px 0px'>
                <Ptag fontSize='16px' letterSpacing='0.5px' fontWeight='300'>
                  {"Health Benefits"}
                </Ptag>
                <Ptag fontSize='16px' fontWeight='300' letterSpacing='0.3px'>
                  {"₹" + formatAmount(props.paymentValues['platform_fee'] || 0)}
                </Ptag>
              </SubComponentRow>
            }
            {
              !!props.paymentValues['gpa_cost'] &&
              <SubComponentRow margin='0 0 3px 0px'>
                <Ptag fontSize='16px' letterSpacing='0.5px' fontWeight='300'>
                  {"GPA Cost"}
                </Ptag>
                <Ptag fontSize='16px' fontWeight='300' letterSpacing='0.3px'>
                  {"₹" + formatAmount(props.paymentValues['gpa_cost'] || 0)}
                </Ptag>
              </SubComponentRow>
            }
            {!!props.paymentValues['discount'] && renderAnnualDiscountRow('Monthly Discount', props.paymentValues['discount'] || 0, null,'24px 0 8px 0')}
            {renderSummaryRow("GST (@18%)", props.paymentValues['discounted_tax'] ? props.paymentValues['discounted_tax'] : props.paymentValues['tax'], null, '12px 0 12px 0', 20,400)}
            <Hr />
            {renderSummaryRow(
                  "Total",
                  getTotal(),
                  "#304ffe",'0',28,600
                )}
          </InnerWrapper>
        </Card>
      </Fragment>
    );
  };


    return (
        <AddPopUpDiv onClick={closePaymentPopup}>
        <Innerpopup >
            <SubInnerDiv>
                <FirstRow>
                    <Ptag fontSize='24px' fontWeight='bold'>
                        Subscription break-up
                    </Ptag>
                    <CrossButton >
                        <img style={{'cursor': 'pointer'}} src={popupcrossbutton} onClick = {closePaymentPopup} width="24px" height="24px" />
                    </CrossButton>
                </FirstRow>
                {paymentSummary()}
            </SubInnerDiv>
        </Innerpopup>
    </AddPopUpDiv>
    );
}
const AddPopUpDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index:999;
  background-color: rgba(0, 0, 0, 0.5);
`
const Innerpopup = styled.div`
  position: absolute;
  left: 25%;
  right: 25%;
  top: 5%;
  bottom: 5%;
  margin: auto;

`
const SubInnerDiv = styled.div`
width:100%;
display:flex;
flex-direction:column;
padding:50px 50px 190px 50px;
background: #ffffff;
border-radius: 10px;
`
const FirstRow = styled.div`
justify-content: space-between;
display: flex;
`
const CrossButton = styled.p`
 
`

const Card = styled.div`
  display:flex;
  flex-direction:column;
  background-color: #ffffff;
  /* box-shadow: 0 1px 4px 0px rgba(0, 0, 0, 0.15); */
  /* margin-top:12px; */
  & + p {
    margin: 3.6rem 0 2.4rem 0;
  }
`;
const FlexRow = styled.div`
width: 100%;
display: flex;
justify-content: space-between;
margin: ${props => props.margin};
`;

const InnerWrapper = styled.div`
  padding:30px 18px 32px 18px;
`;

const Hr = styled.div`
  background: #9b9b9b;
  height: 1px;

  & + div {
    margin-top: 1.6rem;
  }
`;

const SubComponentRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: ${props => props.margin ? props.margin : '0px'}
`

export default PaymentPopup
